<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title style="font-size: 13px; margin-left: 10px; text-align: left;" [ngClass]="{'adjustedTitleFont': setting.configuration.uIoptions?.homePageOption == 10}">{{ title | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="false" [ngClass]="{'disable-background-color': !this.setting.UIshowBackground}">
  <div class="default-content">
    <!--<img class="center-block full-logo" logo />-->
    <img class="center-block full-logo" style="height: 120px;" [src]="logo" />

    <br>

      <div>
        <!--
        @if(!useCustomAPI) {
        -->
          @switch (step) {
            @case ('email') {
              <div>
                <auth-register-form [fromDesktopCheckout]="fromDesktopCheckout" (onSubmit)="onEmailForm($event)"></auth-register-form>
              </div>
            }
            @case ('registration') {
              <div>
                <!--
                <p class="text-center" color="primary" [translate]="'EmailVerification.YouHaveReceivedACodeMessage'"
                  [translateParams]="{ email: emailCode.email }">
                </p>
                -->
                <p class="text-center" style="margin-top: 0px;"><a class="notice-text"
                (click)="notReceivedAnyCode()">{{ 'EmailVerification.NotReceivedMessage' | translate }}</a></p>

                <!--to be modified for the new registration-->
                <!--
                <auth-confirm-registration-form (onSubmit)="onRegistrationCompleted()" [emailCode]="emailCode" [useCustomAPI]="useCustomAPI">
                </auth-confirm-registration-form>
                -->
                <auth-confirm-registration-form (onSubmit)="onRegistrationCompleted()" [emailCode]="emailCode" [customRegistration]="RegistrationConfigurationData" [useCustomAPI]="useCustomAPI" [locations]="locations">
                </auth-confirm-registration-form>
              </div>
            }
            @case ('completed') {
              <div>
                <h2>{{ 'Auth.CongratulationRegistrationCompleted' | translate }}</h2>
              </div>
            }
          }
        <!--
        } @else {

          <auth-confirm-registration-form (onSubmit)="onRegistrationCompleted()" [emailCode]="emailCode" [customRegistration]="RegistrationConfigurationData" [useCustomAPI]="useCustomAPI">
          </auth-confirm-registration-form>
        }
        -->
        
      </div>
    </div>
  </ion-content>